import React from "react";
import { languageHelper } from "../../config/helperFunctions";

export default function HelpModal() {
  const [showModal, setShowModal] = React.useState(false);
  return (
    <>
      <button className="flex gap-1 items-center bg-[#7B20C7] p-2 rounded-md  text-[#fff] text-xs font-semibold "
        type="button" onClick={() => setShowModal(true)} >
        <span>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" className="fill-[#fff]" height="10" width="10">
            <path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z" /></svg>
        </span >
        {languageHelper("Help")}
      </button>
      {
        showModal ? (
          <>
            <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
              <div className="relative mx-auto w-1/4">
                {/*content*/}
                <div className="border-0 rounded-lg shadow-lg relative flex flex-col  bg-white outline-none focus:outline-none overflow-y-auto shiftmodel">
                {/*header*/}
                <div className="flex items-start justify-center p-5 border-solid border-blueGray-200 rounded-t">

                  <h1 className="text-xl text-[#7B20C7]">{languageHelper("Help")}</h1>
                  <button
                    className=" ml-auto  float-right text-2xl" onClick={() => setShowModal(false)} >
                    <span className="text-[#7B20C7]"> × </span>
                  </button>
                </div>
                {/*body*/}
                <div className="relative p-4 text-start">
                  <p className=" text-[#6f6b7d] text-sm">
                    You should click on one/multiple item to mark it as Started Cooking or Done.<br />
                    You can not select any item for Take Away or Delivery type orders, as you need to deliver these type of orders as a pack Blue color indicates Started Cooking, where green color indicates that the item is Done cooking.
                    Until an order is closed from POS Panel, that order will remain here
                  </p>
                </div>

              </div>
            </div>
          </div>
        
      <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
    </>
  ) : null
}
    </>
  );
}
